<template>
  <v-container
    fluid>
    <v-row>
      <v-col
        v-if="assessments.length === 0 && showOTJGraph === false">
        <v-alert
          :value="true"
          type="info"
          class="white--text"
          transition="scale-transition">
          No results have been entered.
        </v-alert>
      </v-col>
      <v-col
        cols="12"
        v-for="(skillArray, strand) in assessments"
        :key="strand">
        <v-card class="mb-4">
          <v-expansion-panels
            :value="[0]"
            multiple
            class="elevation-0">
            <v-expansion-panel>
              <v-expansion-panel-header
                class="font-weight-bold"
                v-if="assessmentsDescript[strand]">
                {{ assessmentsDescript[strand] }}
              </v-expansion-panel-header>

              <v-expansion-panel-header
                class="font-weight-bold"
                v-else>
                {{ strand }}
              </v-expansion-panel-header>

              <v-expansion-panel-content>
                <v-card-text
                  class="caption pt-0"
                  v-if="assessmentComments[strand]">{{ assessmentComments[strand] }}</v-card-text>
                <v-data-table
                  :headers="headers"
                  :items="skillArray"
                  :mobile-breakpoint="0"
                  :items-per-page="20"
                  hide-default-footer>
                  <template
                    slot="headerCell"
                    slot-scope="props">
                    <span class="font-weight-bold">
                      {{ props.header.text }}
                    </span>
                  </template>
                  <template
                    slot="items"
                    slot-scope="props">
                    <td class="font-weight-bold">{{ props.item.termDescript }}</td>
                    <td
                      class="text-center"
                      v-for="year in years"
                      :key="year">{{ props.item[year] }}</td>
                  </template>
                </v-data-table>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-card>
      </v-col>
    </v-row>

    <v-row v-if="showOTJGraph">
      <v-col
        cols="12"
        v-for="(otjArr, otjStrand) in assessmentOTJArr"
        :key="otjStrand">
        <v-card class="mb-4">
          <v-expansion-panels
            :value="[0]"
            multiple
            class="elevation-0">
            <v-expansion-panel>

              <v-expansion-panel-header class="font-weight-bold">
                {{ otjStrand }} OTJ
              </v-expansion-panel-header>

              <v-expansion-panel-content>

                <v-img :src="graphImageUrl[otjStrand]"/>

                <v-data-table
                  :headers="assessmentHeaders"
                  :items="otjArr"
                  :mobile-breakpoint="0"
                  :items-per-page="20"
                  hide-default-footer
                >
                  <template
                    slot="headerCell"
                    slot-scope="props">
                    <span class="font-weight-bold">
                      {{ props.header.text }}
                    </span>
                  </template>
                  <template
                    slot="items"
                    slot-scope="props">
                    <td class="font-weight-bold">{{ props.item.termDescript }}</td>
                    <td
                      class="text-center"
                      v-for="otjYears in formYears"
                      :key="otjYears">{{ props.item[otjYears] }}</td>
                  </template>
                </v-data-table>

              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-card>
      </v-col>

    </v-row>

  </v-container>
</template>

<script>
export default {
  data: () => ({
    headers: [
      {
        text: 'Assessment',
        align: 'left',
        sortable: false,
        value: 'termDescript'
      }
    ],

    assessmentHeaders: [
      {
        text: 'Assessment',
        align: 'left',
        sortable: false,
        value: 'termDescript'
      }
    ],

    assessments: [],
    assessmentComments: [],
    years: [],
    assessmentsDescript: [],
    showOTJGraph: false,
    graphImageUrl: [],
    assessmentOTJArr: [],
    formYears: [],
    otjArr: []
  }),
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.$store.commit('toggle_dialog', true)

      // Get Assessment OTJ Config
      vm.$http.get('getOTJconfigV2/' + vm.$store.state.Dbasename)
        .then(resp => {
          if (resp.data.showOTJGraph === true) {
            vm.showOTJGraph = resp.data.showOTJGraph
            // vm.getOtjGraphs()

            vm.$http.get('pupilsV2/' + vm.$store.state.Dbasename + '/' + vm.$store.state.pupilId + '/otjGraphsV2')
              .then(resp => {
                vm.graphImageUrl = resp.data.graphImageUrl
                vm.assessmentOTJArr = resp.data.assessmentOTJArr
                vm.formYears = resp.data.formYears
                resp.data.formYears.forEach(studYear => {
                  vm.assessmentHeaders = vm.assessmentHeaders.concat({
                    text: studYear,
                    value: studYear,
                    sortable: false,
                    align: 'center'
                  })
                })
              })
          }
        })

      // Get Assessment data
      vm.$http.get('pupilsV2/' + vm.$store.state.Dbasename + '/' + vm.$store.state.pupilId + '/assessmentsV2')
        .then(resp => {
          vm.assessments = resp.data.assessmentsArr
          vm.assessmentComments = resp.data.assessmentComments
          vm.assessmentsDescript = resp.data.descriptionArr
          vm.years = resp.data.years
          resp.data.years.forEach(year => {
            vm.headers = vm.headers.concat({
              text: year,
              value: year,
              sortable: false,
              align: 'center'
            })
          })
          vm.$store.commit('loading', false)
        })
    })
  }
}
</script>
